import { lazy, FC, Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
// import { MasterLayout } from '../../_metronic/layout/MasterLayout'
import MasterLayout from '../app/layout/MasterLayout';
import Spinner from '../app/components/spinner';
import { useAuth } from '../app/auth';
import ProtectedRoute from './ProtectedRoute';
import { AppPermissions } from './AppPermissions';
import { UserBasedRedirector } from 'app/components/routing/UserBasedRedirector';

const CompanyPage = lazy(() => import('../features/company/index'));
const ProjectPage = lazy(() => import('../features/project'));

// const EpisodeLinePage = lazy(() => import("../features/episode/lines"));

const ControlPanelPage = lazy(() => import('../features/controlPanel/index'));

const ManageTasksPage = lazy(() => import('../features/manage-tasks'));

//const CompanyDetailsPage = lazy(() => import('../features/company/details'))
const NotFoundPage = lazy(() => import('../app/errors/not-found/NotFound'));
const PrivateRoutes = () => {
  return (
    <Routes>
      <Route element={<MasterLayout />}>
        <Route path='notfound' element={<NotFoundPage />} />
        <Route path='*' element={<UserBasedRedirector />} />

        <Route
          path='/companies/*'
          element={
            <ProtectedRoute requiredPermissions={[AppPermissions.types.tazmeenEmployee]}>
              <SuspensedView>
                <CompanyPage />
              </SuspensedView>
            </ProtectedRoute>
          }
        />

        <Route
          path='/projects/*'
          element={
            <ProtectedRoute requiredPermissions={[AppPermissions.types.clientEmployee]}>
              <SuspensedView>
                <ProjectPage />
              </SuspensedView>
            </ProtectedRoute>
          }
        />

        <Route
          path='/control-panel/*'
          element={
            <ProtectedRoute requiredPermissions={[AppPermissions.types.tazmeenEmployee]}>
              <SuspensedView>
                <ControlPanelPage />
              </SuspensedView>
            </ProtectedRoute>
          }
        />

        <Route
          path='/manage-tasks/*'
          element={
            <ProtectedRoute
              requiredPermissions={[
                AppPermissions.types.clientEmployee,
                //  AppPermissions.roles.QcEmp,
              ]}
            >
              <SuspensedView>
                <ManageTasksPage />
              </SuspensedView>
            </ProtectedRoute>
          }
        />
      </Route>
    </Routes>
  );
};

export const SuspensedView: FC<any> = ({ children }) => {
  return <Suspense fallback={<Spinner />}>{children}</Suspense>;
};

export { PrivateRoutes };
